import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { Video, VideoProps } from '@/decodo/components/atoms/Video';

export interface VideoStrapiProps {
  url: VideoProps['url'];
}

export default function VideoStrapi({
  block,
}: BlockComponentModel<VideoStrapiProps>) {
  return <Video {...block} />;
}
